import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import {ViewEncapsulation} from '@angular/core';
import swal from 'sweetalert2';
import { DecisionModel } from 'src/app/models/DecisionModel';
import { DecisionService } from 'src/app/services/DecisionService';
import { DecisionEntryComponent } from '../decision-entry/decision-entry.component';

@Component({
  selector: 'app-decision',
  templateUrl: './decision.component.html',
  styleUrls: ['./decision.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DecisionComponent implements OnInit {
  patientcode = '' ;
  Patientname = '';

  decdate =formatDate(new Date(), 'yyyy-MM-dd', 'en');
  declocation = '' ;
  decnotes = '' ;
  userid = '' ;
  username = '' ;
  wk_font = 2;
  wk_fontsize = '2ch';
  decisionList : DecisionModel[]=[];
  disablepharnacy =false;
  chkuser='';
  constructor(public decision: DecisionModel,
                private dialogref: MatDialog,
                public storage: LocalStorageService,
                public decisionService :DecisionService,
              ) { }

  ngOnInit(): void {
    this.patientcode = this.storage.retrieve('stgPatientCode');
    this.Patientname = this.storage.retrieve('stgPatientName');
    this.decdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
    this.RetriveDecision();
    if(this.storage.retrieve('stgGroup') !='2'){this.disablepharnacy = true}else{this.disablepharnacy = false}

  }
  RetriveDecision(){
    this.decisionList = [];
        this.decisionService.getDecisionPatient(this.patientcode).subscribe((data: DecisionModel[]) => {
              for (let i = 0; i < data.length; i++) {
                this.decisionList[i] = data[i];
                this.decisionList[i].decdate =formatDate(data[i].decdate, 'yyyy-MM-dd', 'en');
              }
            })
  }
  ZoomIn(){
    this.wk_font  = this.wk_font  + 0.5;
    this.wk_fontsize = this.wk_font + 'ch';
  }
  ZoomOut(){
    this.wk_font  = this.wk_font  - 0.5;
    this.wk_fontsize = this.wk_font + 'ch';
  }
  EditDecision(item: DecisionModel){
    this.chkuser = item.username;
    if( item.username == this.storage.retrieve('stgusername') )
      {                          ///----------- for searching pop up send variables from table-----------
    this.storage.store('stgPatientCode',item.patientcode);
    this.storage.store('stgVisitDate',item.decdate)
    const dialogRef = this.dialogref.open(DecisionEntryComponent,
      {
        data: {
          dataKey: this.decision,
        },
        width: '50vw',
        height: '50vw',
      });
    dialogRef.afterClosed().subscribe(result => {
    this. RetriveDecision();
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.RetriveDecision();
        dialogSubmitSubscription.unsubscribe();
      });
    }
    else
    {
      this.MesgWarrning();
    }
  }
    MesgWarrning(){

            swal({
              title: 'Check User',
              text:'Editing or deleting this medical record allowed only for: ' + this.chkuser,
              type: 'warning',
              showCancelButton: false,
              confirmButtonText: 'OK',
              //cancelButtonText: 'No, keep it',
            })
            ;

          }
  DeleteDecision(){

      this.decisionService.deleteDecision(this.storage.retrieve('stgVisitDate'),this.storage.retrieve('stgPatientCode'),this.userid).subscribe(
          (data: DecisionModel) => {
            this.RetriveDecision();
          }
        );
        this. RetriveDecision();
  }
  OpenDialog(){
    if(this.patientcode !='0000' || this.patientcode != null ){

    var wk_Date =formatDate(new Date(), 'yyyy-MM-dd', 'en')
    this.storage.store('stgVisitDate',wk_Date )
    this.storage.store('stgPatientCode',this.patientcode);


    const dialogRef = this.dialogref.open(DecisionEntryComponent,
      {
        data: {
          dataKey: this.decision
        },
        width: '50vw',
        height: '50vw',
      });
    dialogRef.afterClosed().subscribe(result => {
      this.RetriveDecision();
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.RetriveDecision();
        dialogSubmitSubscription.unsubscribe();
      });
    }

  }
  MessegeDelete(item :DecisionModel){
    if( item.username == this.storage.retrieve('stgusername') )
      {
    swal({
          title: 'Are you sure?',
          text: 'You will not be able to recover this record!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, keep it',
        }).then(
          () => {
            this.storage.store('stgPatientCode',item.patientcode);
            this.storage.store('stgVisitDate',item.decdate)
            this.userid = item.userid;
            this.DeleteDecision();
            swal('Deleted!', 'Your record has been deleted.', 'success');
          },
          function (dismiss) {
            if (dismiss === 'cancel') {
              swal('Cancelled', 'Your record is safe :)', 'error');
            }
          }
        );
      }
      else
      {
        this.MesgWarrning();
      }
  }
}
